module.exports = __webpack_public_path__ + "img/p3_2.8916415f.png";